<template>
  <div id="highChart"></div>
</template>

<script>
import Highcharts from 'highcharts'
import loadExporting from 'highcharts/modules/exporting'
loadExporting(Highcharts)
export default {
  props: ['chartOptions', 'globalOption', 'resultChartData', 'compareChartData'],
  name: 'HighChart',
  data () {
    return {
      styles: {},
      highChart: null
    }
  },
  watch: {
    chartOptions () {
      this.initChart()
    },
    // 接收到result資料時更新圖表
    resultChartData: {
      handler () {
        const type = this.resultChartData.type
        this.highChart.update({
          series: [
            {
              name: type,
              _colorIndex: type === 'desktop' ? 0 : type === 'mobile' ? 1 : 2,
              _symbolIndex: type === 'mobile' ? 1 : 0,
              data: this.resultChartData[type]
            }
          ]
        })
      },
      deep: true
    },
    // 接收到compare資料時更新圖表
    compareChartData: {
      handler () {
        this.highChart.xAxis[0].setCategories(this.compareChartData.nameList)
        if (this.compareChartData) {
          const { SITotalUU, SIReachUU, SVTotalUU, SVReachUU, LINETotalUU, LINEReachUU } = this.compareChartData.dataList
          this.highChart.update({
            series: [
              { name: 'SI-TotalUU', data: SITotalUU },
              { name: 'SI-ReachUU', data: SIReachUU },
              { name: 'SV-TotalUU', data: SVTotalUU },
              { name: 'SV-ReachUU', data: SVReachUU },
              { name: 'LINE-TotalUU', data: LINETotalUU },
              { name: 'LINE-ReachUU', data: LINEReachUU }
            ]
          })
        } else {
          this.highChart.update({
            series: [
              { data: this.compareChartData.dataList.mobileTotalUU },
              { data: this.compareChartData.dataList.mobileReachUU },
              { data: this.compareChartData.dataList.mobileDirectTotalUU },
              { data: this.compareChartData.dataList.desktopTotalUU },
              { data: this.compareChartData.dataList.desktopReachUU },
              { data: this.compareChartData.dataList.desktopDirectTotalUU }
            ]
          })
        }
      },
      deep: true
    },
    styles () {
      this.initChart()
    }
  },
  mounted () {
    this.initChart()
  },
  methods: {
    initChart () {
      if (this.globalOption) {
        Highcharts.setOptions(this.globalOption)
      } else {
        Highcharts.setOptions({
          global: {
            useUTC: false
          },
          // 基礎尺寸
          chart: {
            spacing: [20, 20, 20, 20, 20, 20],
            minWidth: 992,
            height: this.styles.height || 255,
            style: {
              margin: 'auto',
              fontSize: this.styles.baseSize || '10px'
            }
          },
          // 圖表標題
          title: {
            text: '讀取中...',
            style: {
              color: '#666',
              fontWeight: '600',
              fontSize: this.styles.titleSize || '16px'
            }
          },
          xAxis: {
            title: {
              text: ''
            },
            // X軸標籤文字
            labels: {
              style: {
                fontWeight: '600',
                fontSize: '1.2em'
              }
            }
          },
          yAxis: {
            title: {
              text: ''
            },
            // Y軸標籤文字
            labels: {
              style: {
                fontWeight: '600',
                fontSize: '1.2em'
              }
            }
          },
          plotOptions: {
            series: {
              pointPadding: 0,
              animation: true,
              // 圖表中資料文字
              dataLabels: {
                style: {
                  fontSize: '1.2em'
                }
              }
            }
          },
          legend: {
            y: -10,
            // 圖表數值標示
            itemStyle: {
              fontSize: '1.2em',
              fontWeight: '600',
              fontStyle: 'normal',
              textOverflow: 'ellipsis'
            }
          },
          tooltip: {
            // 內距
            padding: 16,
            // 滑鼠提示標題
            headerFormat: '<span style="font-size: 1.2em">{point.key}</span><br/>',
            // 滑鼠提示內容
            style: {
              fontSize: '1.2em'
            }
          },
          // logo
          credits: {
            enabled: false
          }
        })
      }
      /* eslint-disable */
      this.highChart = new Highcharts.chart(this.$el, this.chartOptions)
    }
  }
}
</script>

<style lang="scss" scoped>
.highcharts-root {
  width: 100%;
  height: 100%;
}
</style>
